import { useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { HOME, NavigateToHome, getUserMenu, saveMenu, saveUserProfil } from "../../Utils/Utils";
import { loginUser } from "../../services/LoginService";

export const LoginForm = () => {
  const { register, handleSubmit } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);
  const navigate = useNavigate()

  const onSubmit = async (data) => {
    setIsSubmit(true)
    loginUser(data).then((res) => {
      if (res.data) {
        const data = {
          ...res.data,
        }
        const userMenu = res.data.permissions
        saveMenu(userMenu)
        saveUserProfil(data)
        if (getUserMenu().length === 0) {
          navigate('/pas-autorise')
        } else {
          navigate(NavigateToHome())
        }
      }
    }).catch((err) => {
      setIsSubmit(false)
      if (err.code === "ERR_BAD_REQUEST") {
        toast.error('Verifier vos identifiants')
      }
    })

  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} className="font-mtn">
        <div class="grid gap-2">
          <div class="grid gap-1">
            <label className="input input-bordered flex items-center gap-2">
              <input type="text" className="grow" placeholder="name@exampl"
                {...register("username", {
                  required: "Please enter your username.",
                })} />
            </label>

            <label className="input input-bordered flex items-center gap-2 mt-4 mb-2">
              <input className="grow" id="password"
                placeholder="Mot de passe"
                type="password"
                {...register("password", {
                  required: "Please enter your Email.",
                })} />
            </label>
            <div className="flex">
              <Link to={`${HOME}/mot-de-passe-oublie`} className="text-sm ml-auto underline">Mot de passe oublié ?</Link>
            </div>
          </div>
          <button
            type="submit"
            disabled={isSubmit ? true : false}
            className={`${!isSubmit
              ? "text-slate-900 bg-amber-300"
              : "text-slate-800 bg-slate-200 "
              } inline-flex items-center justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 shadow hover:bg-slate-900 hover:text-white h-9 px-4 py-2`}

          >
            {isSubmit ? "Veuillez patientez... " : "Se connecter à mon espace"}{" "}
            {isSubmit ? (
              <span className="loading loading-dots loading-xs"></span>
            ) : null}
          </button>
        </div>
      </form>
    </>
  );
};
